// 首页的接口
import request from '@/utils/request'

// 申请入驻表单提交
export function enterApply(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/enterApply',
    method: 'post',
    data,
    headers: {
      isToken: true
    }
  })
}

// 查询入驻申请过程
export function getJgrzGcList(data) {
  return request({
    url: '/sc/ticketMain/api/factJgrzgcxx/myPage',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 查询入驻申请过程
export function getJgrzList(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/pageTab',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 下载文件模板
export function downloadFileTemplateManage(id) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/system/api/sysFileTemplateManage/downloadTemplate/' + id
}

// 查看机构详情所有的附件
export function getJgFileList(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/getJgFileList',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 机构入驻申请文件预览
export function printPdfView(params) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factJgjbxxb/previewJgrzsqFile?' + params
}

// 服务资质文件预览
export function printPdfView2(params) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factFwjbxxb/previewFwzzFile?' + params
}

// 下载附件材料
export function downloadFileRecord(params) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factJgjbxxb/downloadJgrzsqFile?' + params
}

// 删除附件材料
export function removeFileRecord(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/removeJgrzsqFile',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 查看机构详情所有的附件
export function getUpdateJgFileList(data) {
  return request({
    url: '/sc/ticketMain/api/factJgxxxgsq/getJgxgFileList',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 修改资质文件预览
export function printUpdatePdfView(params) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factJgxxxgsq/previewJgxgFile?' + params
}

// 下载修改资质
export function downloadUpdateFileRecord(params) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factJgxxxgsq/downloadJgxgFile?' + params
}

// 删除修改资质
export function removeUpdateFileRecord(data) {
  return request({
    url: '/sc/ticketMain/api/factJgxxxgsq/removeJgxgFile',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 申请修改入驻表单提交
export function updateEnterApply(data) {
  return request({
    url: '/sc/ticketMain/api/factJgxxxgsq/applyOrAudit',
    method: 'post',
    data,
    headers: {
      isToken: true
    }
  })
}

// 查询更新入驻申请过程
export function getUpdateJgrzList(data) {
  return request({
    url: '/sc/ticketMain/api/factJgxxxgsq/myApplyRecord',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

//  查询申请修改机构详情信息
export function getUpdateJgDetail(data) {
  return request({
    url: '/sc/ticketMain/api/factJgxxxgsq/detail',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 机构入驻备案表单pdf下载
export function pdfUpload(params) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factJgjbxxb/printJgrzsqPdf?' + params
}

//  查询机构详情信息
export function getJgDetail(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/detail',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 查询服务机构类型数组
export function getfwJgLxType() {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/fwlxParentAndChildList',
    method: 'get',
    headers: {
      isToken: true
    }
  })
}
// 修改用户密码
export function updateUserPassWord(data) {
  return request({
    url: '/sc/system/api/sysUser/updatePasswordByUserName',
    method: 'post',
    data,
    headers: {
      isToken: true
    }
  })
}

// 机构修改审核提交
export function applyOrAudit(data) {
  return request({
    url: '/sc/ticketMain/api/factJgxxxgsq/applyOrAudit',
    method: 'post',
    data,
    headers: {
      isToken: true
    }
  })
}

// 办件撤回接口
 export function revokeApply(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/revocation',
    method: 'post',
    data,
    headers: {
      isToken: true
    }
  })
}
